import Layout from '../../views/interestRate/purchasingInterestRate/Index'
import List from '../../views/interestRate/purchasingInterestRate/List'
import Edit from '../../views/interestRate/purchasingInterestRate/Edit'
import Create from '../../views/interestRate/purchasingInterestRate/Create'
import Show from '../../views/interestRate/purchasingInterestRate/Show'
import Permissions from '@/permissions'

export const purchasingInterestRateRouters = {
  path: 'purchasing-interest-rate',
  component: Layout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.interestRate.purchasing.manage],
    groups: 'purchasing-interest-rate'
  },
  children: [
    {
      path: '',
      name: 'list-purchasing-interest-rate',
      component: List,
      meta: {
        permissions: [Permissions.backend.interestRate.purchasing.list],
        groups: 'purchasing-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Purchasing Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីបង់រំលោះ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'edit/:id',
      name: 'edit-purchasing-interest-rate',
      component: Edit,
      meta: {
        permissions: [Permissions.backend.interestRate.purchasing.edit],
        groups: 'purchasing-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Purchasing Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីបង់រំលោះ'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'create',
      name: 'create-purchasing-interest-rate',
      component: Create,
      meta: {
        permissions: [Permissions.backend.interestRate.purchasing.store],
        groups: 'purchasing-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Purchasing Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីបង់រំលោះ'
          },
          {
            name_en: 'Create',
            name_km: 'បង្កើត'
          }
        ]
      }
    },
    {
      path: 'show/:id',
      name: 'show-purchasing-interest-rate',
      component: Show,
      meta: {
        permissions: [Permissions.backend.interestRate.purchasing.show],
        groups: 'purchasing-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Purchasing Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីបង់រំលោះ'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
